'use client';

import { jsx } from 'react/jsx-runtime';
import { convertCssVariables } from '../convert-css-variables/convert-css-variables.mjs';
import { useMantineStyleNonce, useMantineCssVariablesResolver } from '../Mantine.context.mjs';
import { useMantineTheme } from '../MantineThemeProvider/MantineThemeProvider.mjs';
import { getMergedVariables } from './get-merged-variables.mjs';
import { removeDefaultVariables } from './remove-default-variables.mjs';
function getColorSchemeCssVariables(selector) {
  return "\n  ".concat(selector, "[data-mantine-color-scheme=\"dark\"] { --mantine-color-scheme: dark; }\n  ").concat(selector, "[data-mantine-color-scheme=\"light\"] { --mantine-color-scheme: light; }\n");
}
function MantineCssVariables(_ref) {
  var cssVariablesSelector = _ref.cssVariablesSelector,
    deduplicateCssVariables = _ref.deduplicateCssVariables;
  var theme = useMantineTheme();
  var nonce = useMantineStyleNonce();
  var generator = useMantineCssVariablesResolver();
  var mergedVariables = getMergedVariables({
    theme: theme,
    generator: generator
  });
  var shouldCleanVariables = cssVariablesSelector === ":root" && deduplicateCssVariables;
  var cleanedVariables = shouldCleanVariables ? removeDefaultVariables(mergedVariables) : mergedVariables;
  var css = convertCssVariables(cleanedVariables, cssVariablesSelector);
  if (css) {
    return /* @__PURE__ */jsx("style", {
      "data-mantine-styles": true,
      nonce: nonce === null || nonce === void 0 ? void 0 : nonce(),
      dangerouslySetInnerHTML: {
        __html: "".concat(css).concat(shouldCleanVariables ? "" : getColorSchemeCssVariables(cssVariablesSelector))
      }
    });
  }
  return null;
}
MantineCssVariables.displayName = "@mantine/CssVariables";
export { MantineCssVariables };